// extracted by mini-css-extract-plugin
export var backdrop = "index-module--backdrop--O+l-b";
export var container = "index-module--container--gFyiE";
export var subtitle = "index-module--subtitle--Wbaqm";
export var title = "index-module--title--tmTeY";
export var viz = "index-module--viz--z-9B6";